import React, { useState } from "react";
import HeroLayout from "../components/HeroLayout";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneNumberField from "../components/PhoneNumberField";
import Slider from "react-slick";
import Lightbox from "yet-another-react-lightbox";
const images = require.context("../assets/images", false);

function GoldenTriangleOberoiHotels() {
    const [formData, setFormData] = useState({
      name: "",
      email: "",
      countryCode: "+91",
      phone: "",
      message: "",
         tour: "Golden Triangle Oberoi Hotels"
       });
       const [captchaToken, setCaptchaToken] = useState(null);  
       const [errors, setErrors] = useState({});
       const [loading, setLoading] = useState(false);
       const [success, setSuccess] = useState("");
     
       // Handle Input Change
       const handleChange = (e) => {
         setFormData({
           ...formData,
           [e.target.name]: e.target.value
         });
     
         setErrors({
           ...errors,
           [e.target.name]: ""
         });
       };
     
       // Validation Function
       const validate = () => {
         let newErrors = {};
     
         if (!formData.name.trim()) {
           newErrors.name = "Name is required";
         }
     
         if (!formData.email.trim()) {
           newErrors.email = "Email is required";
         } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
           newErrors.email = "Invalid email format";
         }
     



      if (!formData.phone.trim()) {
    newErrors.phone = "Phone number is required";
  } else if (!/^[0-9]{7,15}$/.test(formData.phone)) {
    newErrors.phone = "Enter valid phone number";
  }
     
         if (!formData.message.trim()) {
           newErrors.message = "Message is required";
         }
     
         return newErrors;
       };
     
       // Submit Form
       const handleSubmit = async (e) => {
         e.preventDefault();
     
         const validationErrors = validate();
     
         if (Object.keys(validationErrors).length > 0) {
           setErrors(validationErrors);
           return;
         }
     
         try {
          if (!captchaToken) {
  setErrors({ captcha: "Please verify captcha" });
  return;
}
           setLoading(true);
     
           const response = await fetch("https://www.luxurygoldentriangle.com/bkadmn/wp-json/custom/v1/contact_tour", {
             method: "POST",
             headers: {
               "Content-Type": "application/json"
             },
          body: JSON.stringify({
            ...formData,
            phone: `${formData.countryCode} ${formData.phone}`.trim(),
            captcha: captchaToken
          })
           });
     
           const data = await response.json();
     
           if (data.success) {
             setSuccess("Message sent successfully!");
             setErrors({ captcha: "" });
          setFormData({
            name: "",
            email: "",
            countryCode: "+91",
            phone: "",
            message: "",
               tour: "Golden Triangle Oberoi Hotels"
             });
           } else {
             setSuccess(data.message || "Something went wrong.");
           }
     
         } catch (error) {
           setSuccess("Server error. Please try again.");
         } finally {
           setLoading(false);
         }
       };
   
    const [index, setIndex] = useState(-1);
    const [activeSlide, setActiveSlide] = useState(0);
    const [index1, setIndex1] = useState(-1);
    const [activeSlide1, setActiveSlide1] = useState(0);
        const [index2, setIndex2] = useState(-1);
    const [activeSlide2, setActiveSlide2] = useState(0);  
    const images1 = [
      { src: images("./Oberoi-Hotel-Delhi-1-small.jpg") },
      { src: images("./Oberoi-Hotel-Delhi-2-small.jpg") },
      { src: images("./Oberoi-Hotel-Delhi-3-small.jpg") },
      { src: images("./Oberoi-Hotel-Delhi-4-small.jpg") },  
    ];

    const images2 = [
      { src: images("./Oberoi-Amarvilas-5-small-1.jpg") },
      { src: images("./Oberoi-Amarvilas-1-small.jpg") },
      { src: images("./Oberoi-Amarvilas-2-small.jpg") },
      { src: images("./Oberoi-Amarvilas-4-small.jpg") }, 
      { src: images("./Oberoi-Amarvilas-3-small-1.jpg") }, 
    ];

    const images3 = [
      { src: images("./Oberoi-Rajvilas-4-small-1.jpg") },
      { src: images("./Oberoi-Rajvilas-1-small.jpg") },
      { src: images("./Oberoi-Rajvilas-2-small.jpg") },
      { src: images("./Oberoi-Rajvilas-3-small.jpg") }, 
      { src: images("./Oberoi-Rajvilas-5-small.jpg") }, 
    ];

    const NextArrow = ({ onClick }) => (
      <button className="custom-next next2 slick-arrow" onClick={onClick}>
        <img src={images("./Forward.svg")} alt="next arrow" />
      </button>
    );
  
    // Custom Prev Arrow
    const PrevArrow = ({ onClick }) => (
      <button className="custom-prev prev2 slick-arrow" onClick={onClick}>
        <img src={images("./backward.svg")} alt="prev arrow" />
      </button>
    );
   const settings = {
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "0px",
      autoplay: true,           // ✅ AUTO SLIDE
      autoplaySpeed: 30000,      // 3 seconds
      speed: 600,
      arrows: true,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      beforeChange: (oldIndex, newIndex) => {
        setActiveSlide(newIndex);
      },
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            centerMode: false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            centerMode: false
          }
        }
      ]
    };
       
   const settings2 = {
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "0px",
      autoplay: true,           // ✅ AUTO SLIDE
      autoplaySpeed: 30000,      // 3 seconds
      speed: 600,
      arrows: true,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      beforeChange: (oldIndex1, newIndex1) => {
        setActiveSlide1(newIndex1);
      },
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            centerMode: false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            centerMode: false
          }
        }
      ]
    };
   const settings3 = {
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "0px",
      autoplay: true,           // ✅ AUTO SLIDE
      autoplaySpeed: 30000,      // 3 seconds
      speed: 600,
      arrows: true,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      beforeChange: (oldIndex2, newIndex2) => {
        setActiveSlide2(newIndex2);
      },
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            centerMode: false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            centerMode: false
          }
        }
      ]
    };


  return (
    <>
    <HeroLayout>
      <div className="banner-bg" style={{
            backgroundImage:
            `linear-gradient(#370b2e66, #370b2e66), url(${images("./oberoihotel_banner.jpg")})`
        }}
        >
        <div className="container">
            <div className="inner-banner-content full-width center color-white mt-5">
            <h1>Golden Triangle Oberoi Hotels​</h1>
            </div>
        </div>
        </div>

    </HeroLayout>
<div className="tour-details mt-80">
  <div className="container">
    <div className="mb-5">
      <div className="tour-highlight-summary standard-highlight-layout">
        <div className="tour-highlights-card">
          <h2>Tour Highlights</h2>
          <ul>
            <li><span aria-hidden="true">{"\u2605"}</span>Witness the Taj Mahal Glow in the Magic of Sunrise</li>
            <li><span aria-hidden="true">{"\u2605"}</span>Journey Through 8 Magnificent UNESCO World Heritage Sites</li>
			
            <li><span aria-hidden="true">{"\u2605"}</span>Indulge in Curated Stays at the Iconic Oberoi Luxury Hotels</li>
            <li><span aria-hidden="true">{"\u2605"}</span>Explore with Your Own Expert, English-Speaking Private Guide</li>
            <li><span aria-hidden="true">{"\u2605"}</span>Travel in Comfort with an Exclusive Chauffeur-Driven Private Car</li>
			<li><span aria-hidden="true">{"\u2605"}</span>Savour an Unforgettable Candlelit Balcony Dinner at Oberoi Amarvilas with Taj Mahal Views (add on)</li>
			<li><span aria-hidden="true">{"\u2605"}</span>Enjoy Peace of Mind with Round-the-Clock Personalised Assistance</li>
          </ul>
        </div>
       <div className="tour-highlights-cardbkgrey">
		<h2>Tour Details</h2>
          <p><b>Cities</b>: Delhi &bull; Agra &bull; Jaipur</p>
          <p><b>Duration</b>: 6 Nights / 7 Days</p>
          <p><b>Best Time to Visit</b>: September &ndash; March</p>
          <p><b>Tour Type</b>: Private & Luxury</p>
          <p><b>Customizable</b>: Yes — Tailored to Your Preferences</p>
          <p><b>Ideal For</b>: Couples, Families & Small Private Groups</p>
         <p><b>Language</b>: English, Hindi, Spanish, German, Italian, French, Japanese, Chinese</p>
		  

		  

        </div>
      </div>
    </div>
    <h2 className="mb-4">Itinerary</h2>
    <div className="tour-details-card mb-4">
      <div className="row align-items-center">
        <div className="col-md-4">
          <div className="tour-details-card-img">
            <img src={images("./Delhi2.jpeg")} />
            <span>Day 1</span>
          </div>
        </div>
        <div className="col-md-8">
          <div className="border-bottom-card">
            <h3>Arrive in Delhi</h3>
            <p className="colr-prim mb-2 subtxt">Arrive in Delhi</p>
            <p className="mb-3 font-14">
Welcome to Incredible India! When you land, our driver will be there to pick you up and take you straight to your hotel. Once you've checked in, the rest of the day is free.</p>
           <ul className="mb-3">
              <li>Airport Pickup</li>
            </ul>
            <p className="colr-prim mb-3">Meals: NA</p>
          </div>
        </div>
      </div>
    </div>
    <div className="tour-details-card mb-4">
      <div className="row align-items-center">
        <div className="col-md-4">
          <div className="tour-details-card-img">
            <img src={images("./Delhi3.jpeg")} />
            <span>Day 2</span>
          </div>
        </div>
        <div className="col-md-8">
          <div className="border-bottom-card">
            <h3>Delhi</h3>
            <p className="colr-prim mb-2 subtxt">Delhi</p>
            <p className="mb-3 font-14">
              Delhi is a living mosaic of history, flavour, and culture. Your morning kicks off in the atmospheric lanes of <b>Old Delhi</b> — rickshaw through the bustling corridors of <b>Chandni Chowk</b>, India's legendary food capital. Indulge in the city's iconic street food before making your way to the serene grandeur of <b>Humayun's Tomb</b> and the gleaming <b>Bangla Sahib Gurudwara.</b>
              The afternoon takes you to the awe-inspiring <b>Qutub Minar</b> – the world's tallest brick minaret. We will drive past the <b>India Gate</b>, the Secretariat, and Rashtrapati Bhavan. Your evening is yours to explore at your own pace.
              </p>
            <ul className="mb-3">
              <li>Old Delhi</li>
              <li>Humayun Tomb</li>
              <li>Bangla Sahib</li>
              <li>Qutub Minar</li>
              <li>India Gate</li>              
            </ul>
            <p className="colr-prim mb-3">Meals: Breakfast</p>
            <p className="colr-prim mb-3">Optional Experience: Old Delhi Food Walk <span className="specialchar">OR</span> Cook-n-dine with Indian family</p>
          </div>
        </div>
      </div>
    </div>
    <div className="tour-details-card mb-4">
      <div className="row align-items-center">
        <div className="col-md-4">
          <div className="tour-details-card-img">
            <img src={images("./Golden-Traingle-shortTour-India.jpg")} />
            <span>Day 3</span>
          </div>
        </div>
        <div className="col-md-8">
          <div className="border-bottom-card">
            <h3>Delhi – Agra</h3>
            <p className="colr-prim mb-2 subtxt">Delhi – Agra</p>
            <p className="mb-3 font-14">
                After an early breakfast, your driver will take you on a smooth ride to Agra, the city that is home to the world-famous Taj Mahal. Check in to your hotel before heading out to explore the magnificent <b>Agra Fort</b>, a stunning reminiscent of a bygone era. As the day winds down, make your way to <b>Mehtab Bagh</b>, where you can watch the sun set behind the Taj Mahal with the Yamuna river flowing gently below — a view you won't forget.
                </p>
            <ul className="mb-3">
              <li>Agra Fort</li>

            </ul>
            <p className="colr-prim mb-3">Meals: Breakfast</p>
            <p className="colr-prim mb-3">Optional Experience: 2-hour train journey from Delhi to Agra to experience Indian railways</p>
          </div>
        </div>
      </div>
    </div>
    <div className="tour-details-card mb-4">
      <div className="row align-items-center">
        <div className="col-md-4">
          <div className="tour-details-card-img">
            <img src={images("./frg.webp")} />
            <span>Day 4</span>
          </div>
        </div>
        <div className="col-md-8">
          <div className="border-bottom-card">
            <h3>Agra – Jaipur</h3>
            <p className="colr-prim mb-2 subtxt">Airport to Hotel</p>
            <p className="mb-3 font-14">Start your morning with a sunrise visit to the <b>Taj Mahal</b> — one of the seven wonders of the world, built by Emperor Shah Jahan in memory of his beloved wife Mumtaz Mahal. It is a sight best seen in the soft light of dawn.<br></br>
            Head back to the hotel for breakfast, then set off on the drive to Jaipur. Along the way, stop at the fascinating <b>Abhaneri Stepwell</b>, a 16th century water reservoir. <br></br>
            By the time you arrive in Jaipur — the Pink City and a proud UNESCO World Heritage site — you'll already have had a day full of wonders. Check in to your hotel and relax. You may enjoy a traditional Rajasthani meal paired with a lively folk dance performance by local artists (at additional cost).
            </p>
            <ul className="mb-3">
              <li>Taj Mahal</li>
              <li>Fatehpur Sikri</li>
              <li>Abhaneri Stepwell</li>
            </ul>
            <p className="colr-prim mb-3">Meals: Breakfast</p>
          </div>
        </div>
      </div>
    </div>
        <div className="tour-details-card mb-4">
      <div className="row align-items-center">
        <div className="col-md-4">
          <div className="tour-details-card-img">
            <img src={images("./cameljaipur.jpg")} />
            <span>Day 5</span>
          </div>
        </div>
        <div className="col-md-8">
          <div className="border-bottom-card">
            <h3>Jaipur</h3>
            <p className="colr-prim mb-2 subtxt">Jaipur</p>
            <p className="mb-3 font-14">
            Begin your day at the breathtaking <b>Amer Fort</b>, a magnificent hilltop fortress blending Rajput and Mughal architecture. Next, explore the <b>City Palace</b>, a sprawling royal complex housing museums and stunning artifacts of Jaipur's royal legacy. Nearby, marvel at <b>Jantar Mantar</b>, an 18th-century astronomical observatory. Then, drive past the iconic <b>Hawa Mahal</b> — the "Palace of Winds" — famous for its 953 intricately carved windows.<br></br>
            In the afternoon, explore the vibrant <b>local markets of Jaipur</b>, renowned for colorful textiles, gemstones, and traditional handicrafts. End the day with a serene visit to the <b>Birla Temple</b>, a stunning white marble temple beautifully illuminated in the evening.

            </p>
            <ul className="mb-3">
              <li>Amer Fort</li>
              <li>City Palace</li>
              <li>Jantar Mantar</li>
              <li>Hawa Mahal</li>
              <li>Birla Temple</li>
              <li>Galta Ji Temple</li>              
            </ul>
            <p className="colr-prim mb-3">Meals: Breakfast</p>
          </div>
        </div>
      </div>
    </div>
        <div className="tour-details-card mb-4">
      <div className="row align-items-center">
        <div className="col-md-4">
          <div className="tour-details-card-img">
            <img src={images("./delhiimage.jpg")} />
            <span>Day 6</span>
          </div>
        </div>
        <div className="col-md-8">
          <div className="border-bottom-card">
            <h3>Jaipur – Delhi</h3>
            <p className="colr-prim mb-2 subtxt">Jaipur – Delhi</p>
            <p className="mb-3 font-14">The morning will be at leisure. After check-out, your driver will bring you back to Delhi. Once you arrive and settle in to your hotel, the rest of the day is completely free. Spend the evening however you like — browse the local markets, try a new restaurant, or simply relax.</p>

            <p className="colr-prim mb-3">Meals: Breakfast</p>
            <p className="colr-prim mb-3">Optional Experience: Akshardham Temple</p>
          </div>
        </div>
      </div>
    </div>
        <div className="tour-details-card mb-4">
      <div className="row align-items-center">
        <div className="col-md-4">
          <div className="tour-details-card-img">
            <img src={images("./Delhi4.jpeg")} />
            <span>Day 7</span>
          </div>
        </div>
        <div className="col-md-8">
          <div className="border-bottom-card">
            <h3>Depart Delhi</h3>
            <p className="colr-prim mb-2 subtxt">Depart Delhi</p>
            <p className="mb-3 font-14">After breakfast, check-out from the hotel and our driver will drop you at Delhi airport for your onward flight. Our services end here!</p>

            <p className="colr-prim mb-3">Meals: Breakfast</p>
          </div>
        </div>
      </div>
    </div>
    <div className="row tour-summary-row">
      <div className="col-md-12 col-lg-6">
        <div className="tour-details-card tour-summary-left-card mb-4 py-5 px-4">
          <h2 className="mb-3">Inclusions</h2>

          <ul className="tick-list">
            <li>Accommodation in selected or similar hotels on double/twin sharing</li>
            <li>Buffet meals as per itinerary</li>
            <li>Air conditioned Toyota Crysta/Hycross with driver for intercity transfers and sightseeing as per itinerary
            </li>
            <li>Airport pick-up and drop</li>
            <li>English speaking city guides </li>
            <li>Monument entrance fee as per itinerary</li>
            <li>Rickshaw ride in Old Delhi or Jaipur </li>
            <li>Complimentary amenities: Mineral Water and Snack Basket</li>
            <li>All taxes included</li>
            <li>24x7 assistance throughout the tour</li>            
          </ul>
        </div>
      </div>
      <div className="col-md-12 col-lg-6">
        <div className="tour-details-card mb-4 py-5 px-4">
          <h2 className="mb-3">Exclusions</h2>
          <ul className="dot-list-card">
            <li>International and domestic airfare</li>
            <li>Visa (required)</li>
            <li>Travel Insurance</li>
            <li>Optional activities are not included</li>
            <li>Any expense of personal nature like laundry, mini bar, telephone, room service etc.</li>
            <li>Any tour or activity not mentioned above</li>
            <li>Anything not specified in 'Inclusions' column above</li>            
          </ul>
        </div>
        <div className="tour-details-card mb-4 py-5 px-4">
          <h2 className="mb-3">Hotels &amp; Car</h2>
          <p>
            We recommend and use 5 star hotels which may be a standard 5 star
            hotel, a luxury 5 star hotel or a heritage one. Similarly in cars,
            we use Toyota Innova Crysta as standard and upgrades are available
            on request. You can check list of recommended{" "}
            <Link to="/5-star-luxury-hotels">Luxury Hotels here</Link> and list of available{" "}
            <Link to="/car-details">cars/vehicles here</Link>.
          </p>
        </div>
      </div>
    </div>

    <div className="row">
<div className="col-md-4">
    <div class="hotel-list-card-main">
    <div className="row align-items-center">
      <div className="col-md-12">
<div className="carousel-wrapper car-list-cards1">

      <Slider {...settings}>
        {images1.map((img, i) => (
          <div key={i} className="slide-item">
            <img
              src={img.src}
              alt="car"
              onClick={() => setIndex(i)}
              className="carousel-image"
            />
          </div>
        ))}
      </Slider>

      <Lightbox
        open={index >= 0}
        close={() => setIndex(-1)}
        slides={images1}
        index={index}
      />
      </div>
                               <h2 style={{ textAlign: "center" }}>
  <span style={{ color: "#333333" }}>
    <Link
      style={{ color: "#333333" }}
      to="https://www.oberoihotels.com/hotels-in-delhi/"
    >
      The Oberoi, New Delhi
    </Link>
  </span>
</h2>
      
      </div>
    

    </div>
</div>
</div>
      <div className="col-md-4">
        <div className="hotel-list-card-main">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="carousel-wrapper car-list-cards1">
                 <Slider {...settings2}>
        {images2.map((img, i) => (
          <div key={i} className="slide-item">
            <img
              src={img.src}
              alt="car"
              onClick={() => setIndex1(i)}
              className="carousel-image"
            />
          </div>
        ))}
      </Slider>

      <Lightbox
        open={index1 >= 0}
        close={() => setIndex1(-1)}
        slides={images2}
        index={index1}
      />
     
              </div>
                         <h2 style={{ textAlign: "center" }}>
  <span style={{ color: "#333333" }}>
    <Link
      style={{ color: "#333333" }}
      to="https://www.oberoihotels.com/hotels-in-agra-amarvilas-resort/"
    >
      The Oberoi Amarvilas, Agra
    </Link>
  </span>
</h2>
            </div>
            
          </div>
        </div>
      </div>
      <div className="col-md-4">
        <div className="hotel-list-card-main">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="carousel-wrapper car-list-cards1">
                 <Slider {...settings3}>
        {images3.map((img, i) => (
          <div key={i} className="slide-item">
            <img
              src={img.src}
              alt="car"
              onClick={() => setIndex2(i)}
              className="carousel-image"
            />
          </div>
        ))}
      </Slider>

      <Lightbox
        open={index2 >= 0}
        close={() => setIndex2(-1)}
        slides={images3}
        index={index2}
      />
     
              </div>
              <h2 style={{ textAlign: "center" }}>
  <span style={{ color: "#333333" }}>
    <Link
      style={{ color: "#333333" }}
      to="https://www.oberoihotels.com/hotels-in-jaipur-rajvilas-resort/"
    >
      The Oberoi Rajvilas, Jaipur
    </Link>
  </span>
</h2>

            </div>
            
          </div>
        </div>
      </div>

<p style={{ textAlign: "center" }}><b>Disclaimer: The images shown above are copyrights of respective hotels. These are shown for guest reference only.</b></p>


    </div>
    
  </div>
</div>
<div className="tour-form mt-80" id="enquire">
  <img className="top-left-position" src={images("./dance-man.svg")} />
  <img className="bottom-right-position" src={images("./peacock.svg")} />
  <div className="container">
    <div className="form-card">
      <div className="heading center">
        <h2>Enquire Now</h2>
        <p>
          Share your details and concerns with us, and our expert team will get
          in touch at your convenience.
        </p>
      </div>
      <form onSubmit={handleSubmit} noValidate>
        <div className="row">
          <div className="col-md-12 col-lg-6">
            <div className="form-input-group mb-4">
              <label htmlFor="name">
                Name<span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter your name"
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
              {errors.name && <p className="error">{errors.name}</p>}
            </div>
          </div>
          <div className="col-md-12 col-lg-6">
            <div className="form-input-group mb-4">
              <label htmlFor="name">
                Email<span>*</span>
              </label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter your email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <p className="error">{errors.email}</p>}
            </div>
          </div>
          <div className="col-md-12 col-lg-6">
            <PhoneNumberField
              countryCode={formData.countryCode}
              value={formData.phone}
              onChange={handleChange}
              error={errors.phone}
            />
          </div>
          <div className="col-md-12 col-lg-6 messagefield">
            <div className="form-input-group mb-2">
              <label htmlFor="name">
                Message<span>*</span>
              </label>
              <textarea
                name="message"
                className="form-control"
                placeholder="Please share your travel details, including destination, travel dates, number of travelers, hotel preferences, budget, and any special requirements."
                value={formData.message}
                onChange={handleChange}
              />
              {errors.message && <p className="error">{errors.message}</p>}
            </div>
          </div>
                  <div className="col-md-12">
                <ReCAPTCHA
                  sitekey="6Ld4kHosAAAAAKsayfQ1saymv6SeauUSxkHSn55b"
                  onChange={(token) => setCaptchaToken(token)}
                />
                {errors.captcha && <p className="error">{errors.captcha}</p>}
                </div>
        </div>
        <div className="form-btn center mt-3">

              <button type="submit" disabled={loading} className="primary-btn">
                {loading ? "Sending..." : "Submit"} <img src={images("./arrow-right-btn.svg")} alt="Arrow" />
              </button>
                 {success && <p className="success">{success}</p>}
          <p className="center mt-2">
            Not your preferred tour? Click here for a{" "}
            <Link to="/luxury-golden-triangle-enquiry" className="tailor-link">
              <img src={images("./11.png")} />
              Tailor Made Tour
            </Link>
            .
          </p>
        </div>
      </form>
    </div>
  </div>
</div>

    </>
  );
}

export default GoldenTriangleOberoiHotels;
